import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import CloseIcon from "@mui/icons-material/Close";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PhoneIcon from "@mui/icons-material/Phone";
import StorefrontIcon from "@mui/icons-material/Storefront";
import {
  Box,
  Button,
  Container,
  Grid,
  Modal,
  Paper,
  Skeleton,
  ThemeProvider,
  Typography,
  createTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import ActivePlansCardCmp from "../../components/cards/ActivePlansCardCmp";
import {
  AddCreditRequest,
  AddCreditResponse,
  DeactivateSupplierResponse,
  GetFinancialSuppliersForCreditRequestResponse,
  GetLoanTemplatesForCreditRequestRequest,
  GetSuppliersInfoResponse,
} from "../../models/report.model";
import {
  AddCredit,
  DeactivateSupplier,
  GetFinancialSuppliersForCreditRequest,
  GetLoanTemplatesForCreditRequest,
  GetSupplierInfo,
} from "../../services/report.service";

import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { Formik } from "formik";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import DropdownCmp2 from "../../components/dropdown/DropdownCmp2";
import PriceFeildComponent from "../../components/priceFeild/priceFeildComponent";
import useUUID from "../../hook/useUUID";
import { GetStatusResponse } from "../../models/basicInformation.model";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const increaseCreditModalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "500px",
  },
  maxWidth: {
    xs: "300px",
    sm: "400px",
    md: "600px",
    lg: "600px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1350,
      xl: 1536,
    },
  },
});

const theme2 = createTheme({
  direction: "rtl",
});
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const SuppliersListDetail = () => {
  const [open, setOpen] = useState(false);
  const [openDeactiveModal, setOpenDeactiveModal] = useState(false);
  const [openIncreaseCreditModal, setIncreaseCreditModal] = useState(false);
  const [deactiveStatus, setDeactiveStatus] = useState(false);
  const history = useHistory<any>();
  const [resData, setResData] = useState<GetSuppliersInfoResponse>();
  const [financialSuppliersOption, setFinancialSuppliersOption] = useState<
    GetFinancialSuppliersForCreditRequestResponse[]
  >([]);

  const [financialSuppliersValue, setFinancialSuppliersValue] = useState<
    number
  >();
  const [loanTemplatesOption, setLoanTemplates] = useState<GetStatusResponse[]>(
    []
  );
  const [loanTemplatesValue, setLoanTemplatesValue] = useState<
    number | undefined
  >(0);
  const [supplierTemplates, setSuppierTemplates] = useState<any>([]);

  const id = localStorage.getItem("SUPPLIER_ID");
  // history.location.state !== undefined ? history.location.state.id : null;

  const { mutate, isLoading } = useMutation(GetSupplierInfo, {
    onSuccess: (data: GetSuppliersInfoResponse) => {
      if (data) {
        setResData(data);
        setSuppierTemplates(data.supplierTemplates);
      }
    },
    onError: () => {},
  });
  let objSuppliers = {} as GetLoanTemplatesForCreditRequestRequest;

  const handleSelectedDrop = (e: any) => {
    objSuppliers.financialSupplierId = e.target.value;
    objSuppliers.supplierId = Number(id);
    getLoanTemplatesForCreditRequest(objSuppliers);
    e.preventDefault();
    setFinancialSuppliersValue(e.target.value);
    setLoanTemplatesValue(undefined);
  };

  const { mutate: deactivateMutate } = useMutation(DeactivateSupplier, {
    onSuccess: (data: DeactivateSupplierResponse) => {
      if (data) {
        setDeactiveStatus(data);

        toast.success("غیر فعال کردن پذیرنده با موفقیت انجام شد");
        setOpenDeactiveModal(false);
      } else {
        toast.error("غیر فعال کردن پذیرنده انجام نشد");
        setOpenDeactiveModal(false);
      }
    },
    onError: () => {},
  });

  const { mutate: getFinancialSuppliersForCreditRequest } = useMutation(
    GetFinancialSuppliersForCreditRequest,
    {
      onSuccess: (data: GetFinancialSuppliersForCreditRequestResponse[]) => {
        if (data) {
          setFinancialSuppliersOption(data);
        }
      },
      onError: () => {},
    }
  );

  const { mutate: getLoanTemplatesForCreditRequest } = useMutation(
    GetLoanTemplatesForCreditRequest,
    {
      onSuccess: (data: GetStatusResponse[]) => {
        if (data) {
          setLoanTemplates(data);
        }
      },
      onError: () => {},
    }
  );

  const { mutate: addCredit } = useMutation(AddCredit, {
    onSuccess: (data: AddCreditResponse) => {
      if (data) {
        if (data === true) {
          toast.success("افزایش اعتبار با موفقیت ثبت شد.");
          setIncreaseCreditModal(false);
          mutate({
            supplierId: Number(id),
          });
        } else {
          toast.error("درخواست افزایش اعتبار با خطا مواجه شد.");
          setIncreaseCreditModal(false);
        }
      }
    },
    onError: () => {},
  });

  useEffect(() => {
    getFinancialSuppliersForCreditRequest({ supplierId: Number(id) });
  }, [getFinancialSuppliersForCreditRequest, id]);

  const handleDeactiveUserBtn = () => {
    deactivateMutate({ supplierId: Number(id) });
    mutate({ supplierId: Number(id) });
  };

  useEffect(() => {
    if (id) {
      mutate({
        supplierId: Number(id),
      });
    }
  }, [id]);

  const usersInfoClickHandler = () => {
    history.push({
      pathname: "/setting/supplierUsers",
      // state: { id: JSON.parse(localStorage.getItem("SUPPLIER_ID")!) },
      state: { id: Number(id) },
    });
  };

  const handleBranchesClick = () => {
    history.push({
      pathname: "/setting/supplierBranches",
      // state: { id: JSON.parse(localStorage.getItem("SUPPLIER_ID")!) },
      state: { id: Number(id) },
    });
  };

  useEffect(() => {
    if (history.action === "POP") {
      history.push({
        pathname: "/SuppliersList1/SuppliersListDetail",
        // state: { id: JSON.parse(localStorage.getItem("SUPPLIER_ID")!) },
        state: { id: Number(id) },
      });
    }
  }, [history, id]);

  let initialValues: AddCreditRequest = {
    financialSuppliersValue: undefined,
    creditAmountRial: undefined,
    loanTemplateId: undefined,
    supplierId: undefined,
  };

  const numberHandleKeyDown = (event: any) => {
    var key = event.keyCode ? event.keyCode : event.which;

    if (!/[0-9]/.test(event.key) && key !== 8 && key !== 46) {
      event.preventDefault();
    }
  };

  const supplierKeys = useUUID(resData?.supplierTemplates.length);

  return (
    <>
      <ThemeProvider theme={theme}>
        <div>
          {/* supplier card detail info */}

          <Grid container marginBottom={"4rem"}>
            <Grid item xs={12}>
              <Paper
                sx={{
                  backgroundColor: "#F6F8F9",
                  borderColor: "#EDEFEF",
                  borderRadius: "0.5rem !important",
                  padding: "1rem",
                }}
              >
                <Grid
                  container
                  direction={{
                    xs: "column",
                    sm: "column",
                    md: "column",
                    lg: "row",
                    xl: "row",
                  }}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  padding={"1rem"}
                >
                  <Grid item sm={9} xs={12} md={6} lg={5}>
                    <Grid
                      container
                      direction={"row"}
                      justifyContent={{
                        xs: "center",
                        sm: "center",
                        md: "center",
                        lg: "start",
                      }}
                      alignItems={"center"}
                      gap={"1rem"}
                    >
                      <Grid item lg={2}>
                        {resData?.supplierTitle?.logo === "" ? (
                          <StorefrontIcon
                            style={{
                              width: "75px",
                              height: "75px",
                              color: "#9a9e9e",
                              padding: "15px",
                            }}
                            className="suppliersCardImg"
                          />
                        ) : resData?.supplierTitle?.logo ? (
                          <img
                            className="suppliersCardImgDetail"
                            src={`data:image/png;base64,${resData?.supplierTitle?.logo}`}
                            alt=""
                          />
                        ) : (
                          <Skeleton
                            animation="wave"
                            variant="circular"
                            width={80}
                            height={80}
                          />
                        )}
                      </Grid>
                      <Grid item lg={9}>
                        {resData?.supplierTitle?.title ? (
                          <Typography
                            fontWeight={"bold"}
                            color={"#1D4A87"}
                            fontSize={"16px"}
                          >
                            {resData?.supplierTitle?.title}
                          </Typography>
                        ) : (
                          <Skeleton
                            animation="wave"
                            width={100}
                            height={60}
                          ></Skeleton>
                        )}
                        {resData?.supplierTitle?.supplierStatus ? (
                          <Typography
                            color={"#fff"}
                            fontSize={"12px"}
                            sx={{
                              backgroundColor:
                                resData?.supplierTitle.supplierStatus.toLocaleLowerCase() ===
                                "active"
                                  ? "#28A745"
                                  : resData?.supplierTitle.supplierStatus.toLocaleLowerCase() ===
                                    "inactive"
                                  ? "#E6123D"
                                  : resData?.supplierTitle.supplierStatus.toLocaleLowerCase() ===
                                    "suspended"
                                  ? "#EE9D01"
                                  : "gray",
                              borderRadius: "5px",
                              marginTop: "0.5rem",
                              textAlign: "center",
                            }}
                            minWidth={"80px"}
                            maxWidth={"fit-content"}
                            paddingY={"0.3rem"}
                            paddingX={"0.5rem"}
                          >
                            {resData?.supplierTitle.supplierStatusTitle}
                          </Typography>
                        ) : (
                          <Skeleton
                            animation="wave"
                            width={80}
                            height={40}
                          ></Skeleton>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item sm={12} xs={12} md={12} lg={7}>
                    <Grid
                      container
                      justifyContent={{
                        xs: "center",
                        sm: "center",
                        md: "center",
                        lg: "flex-end",
                      }}
                      alignItems={"center"}
                    >
                      {/* credit manage */}
                      {resData?.creditManagePermission ? (
                        <Grid
                          item
                          sm={12}
                          xs={12}
                          md={4}
                          lg={2}
                          textAlign={{
                            xs: "center",
                            sm: "center",
                            md: "center",
                            lg: "left",
                          }}
                          marginTop={{
                            xs: "0.5rem",
                            sm: "0.5rem",
                            md: "0.5rem",
                            lg: "0",
                          }}
                          // marginLeft={"5px"}
                        >
                          <Button
                            onClick={() => setIncreaseCreditModal(true)}
                            className="supplierDetailMenuBtn"
                            sx={{
                              "&:hover": {
                                backgroundColor: "#28A745",
                              },
                              "&:focus": {
                                backgroundColor: "#28A745",
                              },
                              // marginRight: "4rem",
                            }}
                          >
                            <AccountBalanceWalletOutlinedIcon
                              sx={{
                                marginLeft: "5px",
                                color: "#1D4A87",
                              }}
                            ></AccountBalanceWalletOutlinedIcon>
                            <Typography
                              fontWeight={"bold"}
                              whiteSpace={"nowrap"}
                              color={"#1D4A87"}
                            >
                              افزایش اعتبار{" "}
                            </Typography>
                          </Button>
                        </Grid>
                      ) : resData?.stateManagePermission === false ? null : (
                        <Skeleton
                          variant="rectangular"
                          animation="wave"
                          width={100}
                          height={30}
                          sx={{ borderRadius: "5px", marginX: "15px" }}
                        />
                      )}
                      {/* user manage */}
                      {resData?.userManagePermission ? (
                        <Grid
                          item
                          sm={12}
                          xs={12}
                          md={4}
                          lg={2}
                          marginX={"10px"}
                          textAlign={{
                            xs: "center",
                            sm: "center",
                            md: "center",
                            lg: "left",
                          }}
                          marginTop={{
                            xs: "0.5rem",
                            sm: "0.5rem",
                            md: "0.5rem",
                            lg: "0",
                          }}
                        >
                          <Button
                            onClick={usersInfoClickHandler}
                            className="supplierDetailMenuBtn"
                            sx={{
                              "&:hover": {
                                backgroundColor: "#28A745",
                              },
                              "&:focus": {
                                backgroundColor: "#28A745",
                              },
                              // marginRight: "4rem",
                            }}
                          >
                            <InfoOutlinedIcon
                              sx={{
                                marginLeft: "5px",
                                color: "#1D4A87",
                              }}
                            ></InfoOutlinedIcon>
                            <Typography
                              fontWeight={"bold"}
                              whiteSpace={"nowrap"}
                              color={"#1D4A87"}
                            >
                              اطلاعات کاربران
                            </Typography>
                          </Button>
                        </Grid>
                      ) : isLoading ? (
                        <Skeleton
                          variant="rectangular"
                          animation="wave"
                          width={100}
                          height={30}
                          sx={{ borderRadius: "5px", marginX: "15px" }}
                        />
                      ) : null}
                      {/* contact info */}
                      {// resData?.supplierAddresses !== null &&
                      // resData?.supplierAddresses.length !== 0 &&
                      // (resData?.supplierAddresses[0]?.address ||
                      //   resData?.supplierAddresses[0]?.email ||
                      //   resData?.supplierAddresses[0]?.telNumbers)
                      resData?.addressManagePermission ? (
                        <Grid
                          item
                          sm={12}
                          xs={12}
                          md={4}
                          lg={2}
                          marginX={"10px"}
                          textAlign={{
                            xs: "center",
                            sm: "center",
                            md: "center",
                            lg: "left",
                          }}
                          marginTop={{
                            xs: "0.5rem",
                            sm: "0.5rem",
                            md: "0.5rem",
                            lg: "0",
                          }}
                        >
                          <Button
                            onClick={handleBranchesClick}
                            className="supplierDetailMenuBtn"
                            sx={{
                              "&:hover": {
                                backgroundColor: "#28A745",
                              },
                              "&:focus": {
                                backgroundColor: "#28A745",
                              },
                              // marginRight: "4rem",
                            }}
                          >
                            <PhoneIcon
                              sx={{
                                marginLeft: "5px",
                                color: "#1D4A87",
                              }}
                            ></PhoneIcon>
                            <Typography
                              fontWeight={"bold"}
                              whiteSpace={"nowrap"}
                              color={"#1D4A87"}
                            >
                              اطلاعات تماس
                            </Typography>
                          </Button>
                        </Grid>
                      ) : isLoading ? (
                        <Skeleton
                          variant="rectangular"
                          animation="wave"
                          width={100}
                          height={30}
                          sx={{ borderRadius: "5px", marginX: "15px" }}
                        />
                      ) : null}
                      {/* state manage */}
                      {resData?.supplierTitle.supplierStatus?.toLocaleLowerCase() !==
                      "inactive" ? (
                        resData?.stateManagePermission ? (
                          <Grid
                            item
                            sm={12}
                            xs={12}
                            md={4}
                            lg={3}
                            marginLeft={"5px"}
                            textAlign={{
                              xs: "center",
                              sm: "center",
                              md: "center",
                              lg: "center",
                            }}
                            marginTop={{
                              xs: "0.5rem",
                              sm: "0.5rem",
                              md: "0.5rem",
                              lg: "0",
                            }}
                          >
                            <Button
                              onClick={() => setOpenDeactiveModal(true)}
                              className="supplierDetailMenuBtn"
                              sx={{
                                "&:hover": {
                                  backgroundColor: "#E6123D",
                                },
                                "&:focus": {
                                  backgroundColor: "#E6123D",
                                },
                                // marginRight: "4rem",
                              }}
                            >
                              <Typography
                                fontWeight={"bold"}
                                whiteSpace={"nowrap"}
                                color={"#E6123D"}
                                component={"p"}
                              >
                                <DoDisturbIcon
                                  sx={{
                                    marginLeft: "5px",
                                    color: "#E6123D",
                                  }}
                                ></DoDisturbIcon>
                                غیر فعال کردن پذیرنده
                              </Typography>
                            </Button>
                          </Grid>
                        ) : resData?.stateManagePermission === false ? null : (
                          <Skeleton
                            variant="rectangular"
                            animation="wave"
                            width={100}
                            height={30}
                            sx={{ borderRadius: "5px", marginX: "15px" }}
                          />
                        )
                      ) : null}
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
              <Box
                sx={{
                  backgroundColor: "rgba(154,175,196,0.15)",
                  borderRadius: "5px",
                }}
                paddingY={"1rem"}
              >
                <Grid container justifyContent={"center"} alignItems={"center"}>
                  <Grid item lg={1}></Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={2}
                    xl={2}
                    textAlign={"center"}
                    paddingY={{ xs: "0.5rem", lg: "0" }}
                  >
                    <Typography color={"#1D4A87"} fontSize={"14px"}>
                      تعداد اعطا شده: <b>{resData?.assignedLoansCount}</b>
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={3}
                    xl={3}
                    textAlign={"center"}
                    paddingY={{ xs: "0.5rem", lg: "0" }}
                  >
                    <Typography color={"#1D4A87"} fontSize={"14px"}>
                      مجموع اعطا شده:{" "}
                      <b>
                        {resData?.assignedLoansAmountRial.toLocaleString("fa")}
                      </b>{" "}
                      ریال
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={2}
                    xl={2}
                    textAlign={"center"}
                    paddingY={{ xs: "0.5rem", lg: "0" }}
                  >
                    <Typography color={"#1D4A87"} fontSize={"14px"}>
                      تعداد تسویه شده: <b>{resData?.settledLoansCount}</b>
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={3}
                    xl={3}
                    textAlign={"center"}
                    paddingY={{ xs: "0.5rem", lg: "0" }}
                  >
                    <Typography color={"#1D4A87"} fontSize={"14px"}>
                      مجموع تسویه شده:{" "}
                      <b>
                        {resData?.settledLoansAmountRial.toLocaleString("fa")}
                      </b>{" "}
                      ریال
                    </Typography>
                  </Grid>
                  <Grid item lg={1}></Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>

          {/* Active Plans Detail */}
          {
            <div className="suppliersListDetailContent">
              <span className="suppliersListDetailTitle">
                طرح‌های تسهیلاتی فعال
              </span>
              {resData?.supplierTemplates !== null &&
              resData?.supplierTemplates.length === 0 ? (
                <Typography padding={"5rem"} textAlign={"center"}>
                  طرح تسهیلاتی فعالی وجود ندارد
                </Typography>
              ) : isLoading ? (
                // <Backdrop
                //   hidden={false}
                //   open={true}
                //   sx={{ color: "#fff", zIndex: () => 1 }}
                // >
                //   <CircularProgress color="inherit" />
                // </Backdrop>
                <Skeleton
                  variant="rectangular"
                  width={"100%"}
                  height={"17vh"}
                  sx={{ borderRadius: "5px" }}
                />
              ) : (
                supplierTemplates.map((supplier: any, index: any) => (
                  <div
                    key={supplierKeys[index]}
                    className="ActivePlansCardContainer"
                  >
                    <ActivePlansCardCmp {...supplier} />
                  </div>
                ))
              )}
            </div>
          }

          {/* Contact Modal */}

          {/* <div>
            <Modal
              open={open}
              onClose={handleCloseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Box position={"relative"}>
                  <Typography
                    onClick={handleCloseModal}
                    component={"p"}
                    color={"red"}
                    position={"absolute"}
                    top={0}
                    left={0}
                    sx={{ cursor: "pointer" }}
                  >
                    <CloseIcon></CloseIcon>
                  </Typography>
                </Box>
                <Typography
                  component={"p"}
                  display={"block"}
                  textAlign={"center"}
                  fontWeight={"bold"}
                  marginY={"2rem"}
                  fontSize={"16px"}
                >
                  اطلاعات تماس
                </Typography>
<<<<<<< HEAD
                {resData?.supplierAddresses !== null &&
                  resData?.supplierAddresses.map((address) => (
                    <Box key={uuid()} sx={{ direction: "rtl" }}>
                      <Grid container>
                        <Grid item xs={12}>
                          <Box
                            sx={{ border: "1px solid #DAE0E4" }}
                            borderRadius={".5rem"}
                            marginBottom={".6rem"}
                          >
                            {address.address === null ||
                            address.address === "" ? null : (
                              <Grid
                                container
                                direction={"row"}
                                alignItems={"center"}
                                justifyContent={"start"}
                                gap={"1rem"}
                                padding={".5rem"}
                              >
                                <Grid item>
                                  <PlaceIcon fontSize="large"></PlaceIcon>
                                </Grid>
                                <Grid item>
                                  <Typography marginRight={"0.5rem"}>
                                    {address.address}
                                  </Typography>
                                </Grid>
                              </Grid>
                            )}
                            {address.email === null ||
                            address.email === "" ? null : (
                              <Grid
                                container
                                direction={"row"}
                                alignItems={"center"}
                                justifyContent={"start"}
                                gap={"1rem"}
                                padding={".5rem"}
                              >
                                <Grid item>
                                  <MailIcon fontSize="large"></MailIcon>
                                </Grid>
                                <Grid item>
                                  <Typography marginRight={"0.5rem"}>
                                    {address.email}
                                  </Typography>
                                </Grid>
                              </Grid>
                            )}
                            {address.telNumbers === null ||
                            address.telNumbers === "" ? null : (
                              <Grid
                                container
                                direction={"row"}
                                alignItems={"center"}
                                justifyContent={"start"}
                                gap={"1rem"}
                                padding={".5rem"}
                              >
                                <Grid item>
                                  <PhoneIcon fontSize="large"></PhoneIcon>
                                </Grid>
                                <Grid item>
                                  <Typography marginRight={"0.5rem"}>
                                    {address.telNumbers}
                                  </Typography>
                                </Grid>
=======
                {resData?.supplierAddresses.map((address) => (
                  <Box key={uuid()} sx={{ direction: "rtl" }}>
                    <Grid container>
                      <Grid item xs={12}>
                        <Box
                          sx={{ border: "1px solid #DAE0E4" }}
                          borderRadius={".5rem"}
                          marginBottom={".6rem"}
                        >
                          {address.address === null ||
                          address.address === "" ? null : (
                            <Grid
                              container
                              direction={"row"}
                              alignItems={"center"}
                              justifyContent={"start"}
                              gap={"1rem"}
                              padding={".5rem"}
                            >
                              <Grid item>
                                <PlaceIcon fontSize="large"></PlaceIcon>
                              </Grid>
                              <Grid item>
                                <Typography marginRight={"0.5rem"}>
                                  {address.address}
                                </Typography>
                              </Grid>
                            </Grid>
                          )}
                          {address.email === null ||
                          address.email === "" ? null : (
                            <Grid
                              container
                              direction={"row"}
                              alignItems={"center"}
                              justifyContent={"start"}
                              gap={"1rem"}
                              padding={".5rem"}
                            >
                              <Grid item>
                                <MailIcon fontSize="large"></MailIcon>
                              </Grid>
                              <Grid item>
                                <Typography marginRight={"0.5rem"}>
                                  {address.email}
                                </Typography>
                              </Grid>
                            </Grid>
                          )}
                          {address.telNumbers === null ||
                          address.telNumbers === "" ? null : (
                            <Grid
                              container
                              direction={"row"}
                              alignItems={"center"}
                              justifyContent={"start"}
                              gap={"1rem"}
                              padding={".5rem"}
                            >
                              <Grid item>
                                <PhoneIcon fontSize="large"></PhoneIcon>
>>>>>>> feature/supplierUsers
                              </Grid>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  ))}
              </Box>
            </Modal>
          </div> */}

          {/* State Manage Modal */}
          <div>
            <Modal
              open={openDeactiveModal}
              onClose={() => setOpenDeactiveModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={deactiveUserStyle}>
                <Box position={"relative"}>
                  <Typography
                    onClick={() => setOpenDeactiveModal(false)}
                    component={"p"}
                    color={"red"}
                    position={"absolute"}
                    top={0}
                    left={0}
                    sx={{ cursor: "pointer" }}
                  >
                    <CloseIcon></CloseIcon>
                  </Typography>
                </Box>
                <Typography
                  component={"p"}
                  display={"block"}
                  textAlign={"center"}
                  fontWeight={"bold"}
                  marginY={"3rem"}
                  fontSize={"14px"}
                >
                  آیا از{" "}
                  <span style={{ color: "#E6123D" }}>
                    غیر فعال کردن پذیرنده
                  </span>{" "}
                  اطمینان دارید؟
                </Typography>
                <Grid container justifyContent={"center"} gap={"1rem"}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={6}
                    sx={{
                      backgroundColor: "#E6123D",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                    padding={"0.5rem"}
                    maxWidth={"150px !important"}
                  >
                    <Typography
                      textAlign={"center"}
                      color={"#FFF"}
                      fontWeight={"bold"}
                      onClick={handleDeactiveUserBtn}
                    >
                      غیر فعال کردن
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={6}
                    sx={{
                      backgroundColor: "#607D8B",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                    padding={"0.5rem"}
                    maxWidth={"150px !important"}
                  >
                    <Typography
                      textAlign={"center"}
                      color={"#FFF"}
                      fontWeight={"bold"}
                      onClick={() => setOpenDeactiveModal(false)}
                    >
                      انصراف
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Modal>
          </div>

          {/* Increase Credit Modal */}
          <div>
            <Modal
              open={openIncreaseCreditModal}
              onClose={() => setIncreaseCreditModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Formik
                initialValues={initialValues}
                onSubmit={(values: AddCreditRequest) => {
                  values.supplierId = Number(id);
                  values.loanTemplateId = loanTemplatesValue;
                  values.creditAmountRial = Number(
                    String(values.creditAmountRial).replace(/,/g, "")
                  );
                  addCredit(values);
                }}
                validateOnMount={true}
                // validationSchema={userCreditAmountSchema}
              >
                {({
                  handleSubmit,
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Box sx={increaseCreditModalStyle}>
                      <Box position={"relative"}>
                        <Typography
                          onClick={() => setIncreaseCreditModal(false)}
                          component={"p"}
                          color={"red"}
                          position={"absolute"}
                          top={0}
                          left={0}
                          sx={{ cursor: "pointer" }}
                        >
                          <CloseIcon></CloseIcon>
                        </Typography>
                      </Box>
                      <Typography
                        component={"p"}
                        display={"block"}
                        textAlign={"center"}
                        fontWeight={"bold"}
                        marginY={"2rem"}
                        fontSize={"16px"}
                        color={"#1D4A87"}
                      >
                        افزایش اعتبار
                      </Typography>
                      <Grid container direction={"column"} gap={"2rem"}>
                        <Grid item className="suppliersList-addCredit-modal">
                          <DropdownCmp2
                            onBlur={handleBlur}
                            style={{ paddingRight: "0 !important" }}
                            onChange={handleSelectedDrop}
                            value={financialSuppliersValue}
                            label={"تامین کننده مالی*"}
                            options={financialSuppliersOption}
                            name="financialSuppliersValue"
                            id="financialSuppliersValue"
                          />
                        </Grid>
                        <Grid item>
                          <Grid item>
                            <DropdownCmp2
                              onBlur={handleBlur}
                              value={loanTemplatesValue}
                              id="loanTemplateId"
                              label={"طرح تسهیلاتی*"}
                              name="loanTemplateId"
                              onChange={(e: any) => {
                                setLoanTemplatesValue(e.target.value);
                              }}
                              options={loanTemplatesOption}
                              style={{
                                paddingRight: "0 !important",
                                pointerEvents: !financialSuppliersValue
                                  ? "none"
                                  : "auto",
                              }}
                            />
                          </Grid>
                        </Grid>
                        <Grid item sx={{ direction: "rtl" }}>
                          <Grid item>
                            <CacheProvider value={cacheRtl}>
                              <ThemeProvider theme={theme2}>
                                <PriceFeildComponent
                                  onKeyDown={numberHandleKeyDown}
                                  autoFocus={true}
                                  helperText={
                                    touched.creditAmountRial
                                      ? errors.creditAmountRial
                                      : ""
                                  }
                                  error={
                                    touched.creditAmountRial &&
                                    Boolean(errors.creditAmountRial)
                                  }
                                  label={"مبلغ اعتبار (ریال)*"}
                                  placeHolder={"(ریال) مبلغ اعتبار*"}
                                  required={true}
                                  value={values.creditAmountRial}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="creditAmountRial"
                                  id="creditAmountRial"
                                />
                              </ThemeProvider>
                            </CacheProvider>
                          </Grid>
                        </Grid>
                        <Grid item display={"flex"} alignItems={"center"}>
                          <Grid
                            container
                            justifyContent={"center"}
                            gap={"1rem"}
                          >
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={6}
                              sx={{
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                              padding={"0.5rem"}
                              maxWidth={"150px !important"}
                            >
                              <Button
                                fullWidth
                                type="submit"
                                variant="contained"
                                disabled={
                                  !financialSuppliersValue ||
                                  !loanTemplatesValue ||
                                  !values.creditAmountRial
                                }
                                className={
                                  !financialSuppliersValue ||
                                  !loanTemplatesValue ||
                                  !values.creditAmountRial
                                    ? "btnForm disabledBtn"
                                    : "btnForm SuccessDefault"
                                }
                                sx={{ fontWeight: "bold" }}
                              >
                                ثبت
                              </Button>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={6}
                              sx={{
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                              padding={"0.5rem"}
                              maxWidth={"150px !important"}
                            >
                              <Button
                                fullWidth
                                variant="contained"
                                onClick={() => setIncreaseCreditModal(false)}
                                sx={{
                                  backgroundColor: "#607D8B",
                                  color: "#fff",
                                  fontWeight: "bold",
                                  height: "40px",
                                  "&:hover": {
                                    backgroundColor: "#607D8B",
                                  },
                                }}
                              >
                                بازگشت
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Box>
                  </form>
                )}
              </Formik>
            </Modal>
          </div>
        </div>
      </ThemeProvider>
    </>
  );
};

export default SuppliersListDetail;
